import React from 'react';
import { Icons } from './Icons';

const SANS = '"Geist", "Inter", system-ui, sans-serif';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const { fallback, title = 'Something went wrong', description = 'This section failed to load.' } = this.props;
    if (fallback) return fallback;

    return (
      <div style={{
        textAlign: 'center', padding: '2.5rem 1.5rem',
        background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.18)',
        borderRadius: 16, fontFamily: SANS,
      }}>
        <div style={{
          width: 48, height: 48, borderRadius: '50%',
          background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem',
        }}>
          <Icons.AlertTriangle style={{ width: 22, height: 22, color: '#f87171' }} />
        </div>
        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, color: 'rgba(255,255,255,0.85)', margin: '0 0 6px' }}>{title}</h3>
        <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.82rem', margin: '0 0 1.25rem', lineHeight: 1.5 }}>{description}</p>
        <button
          onClick={() => this.setState({ hasError: false, error: null })}
          style={{
            padding: '8px 20px', borderRadius: 9, border: '1px solid rgba(255,255,255,0.1)',
            background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.75)',
            fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer', fontFamily: SANS,
            transition: 'background 160ms, border-color 160ms',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; e.currentTarget.style.borderColor = 'rgba(90,56,253,0.4)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}
        >
          Try Again
        </button>
      </div>
    );
  }
}
